import PropTypes from 'prop-types'
import React from 'react'
import { Add } from '@mui/icons-material'
import { Box, Button } from '@mui/material'

export const AddButton = ({ title, ...props }) => {
  return (
    <Box mt={1}>
      <Button startIcon={<Add />} {...props}>
        {title}
      </Button>
    </Box>
  )
}

AddButton.propTypes = {
  title: PropTypes.string.isRequired,
}
